<template>
    <div>
        <router-view :info="info" :notifications="notifications"/>
        <error-messages />
    </div>
</template>

<script>
    import NavBar from '~/components/Shared/Partials/NavBar';
    import PageFooter from '~/components/Shared/Partials/Footer';
    import UnauthorisedModal from "../components/Shared/UIComponents/UnauthorisedModal";

    export default {
        components: {
            NavBar,
            PageFooter,
            UnauthorisedModal
        },
        data() {
            return {
                unauthorised: false,
            };
        },
        props: ['info', 'notifications'],
        created() {
            this.$eventBus.$on('unauthorised', (unauthorised) => {
                this.unauthorised = unauthorised;
            });
        }
    }
</script>
